import F from 'offline/filter/constants'

// Port of api/fuel/app/classes/filter/package/games/game/prepare/ratings.php
export default {
	run: function(local, global) {
		local.ratings = { users: {}, average: 0, user: null }
		var gameRatings = global.ratings[local.game_id]
		if (gameRatings) {
			var total = 0, count = 0
			var keys = Object.keys(gameRatings)
			for (var i = 0; i < keys.length; i++) {
				var val = Math.round(parseFloat(gameRatings[keys[i]]) * 10) / 10
				if (val) {
					local.ratings.users[keys[i]] = val
					total += val
					count++
				}
			}
			if (count) local.ratings.average = total / count
			if (global.userID && gameRatings[global.userID]) {
				local.ratings.user = Math.round(parseFloat(gameRatings[global.userID]) * 10) / 10
			}
		}
		if (global.ownerType === F.OWNER_BUDDIES && global.buddyRatings && Object.prototype.hasOwnProperty.call(global.buddyRatings, local.game_id)) {
			local.ratings.user = Math.round(parseFloat(global.buddyRatings[local.game_id]) * 10) / 10
		}
		return local
	}
}
